<form class="branded">
    @if (includeFilter) {
    <filter-input (onKeyUp)="filter($event)"></filter-input>
    }
    @if(showRequestorPicker){
    <div class="col-6" style="float: right">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic" matTooltip="select a requestor">
            <mat-label>requestor</mat-label>
            <input matInput [readonly]="true" [value]="selectedRequestor" (click)="searchForRequestorUsers()">
            <button mat-icon-button matSuffix (click)="searchForRequestorUsers()">
                <mat-icon>person_search</mat-icon>
            </button>
        </mat-form-field>
    </div>
    }
    <table id="users" mat-table matSort matSortActive="createDate" matSortDirection="desc"
        [dataSource]="requestsDataSource" multiTemplateDataRows aria-describedby="workflow requests">
        <caption> requests </caption>

        @if (includeCheckbox) {
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <input MatCheckbox type="checkbox" (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" />
            </th>
            <td MatCheckbox mat-cell *matCellDef="let row">
                <input type="checkbox" name="formcheckbox" (click)="$event.stopPropagation()" (change)="select(row)"
                    [checked]="selection.isSelected(row)" />
            </td>
        </ng-container>
        }

        @for (disCol of coreCols; track disCol; let colIndex = $index){
        <ng-container matColumnDef="{{disCol}}">`
            <th mat-header-cell *matHeaderCellDef>
                <span mat-sort-header>{{disCol | convertDisplayLabels}}</span>
            </th>
            <td mat-cell *matCellDef="let element">
                <text-formatter [content]="element[disCol]"></text-formatter>
            </td>
        </ng-container>}

        <ng-container matColumnDef="displayName">
            <th mat-header-cell *matHeaderCellDef [hidden]="true">display name</th>
            <td mat-cell *matCellDef="let element" [hidden]="true">
                <text-formatter [content]="element.displayName"></text-formatter>
            </td>
        </ng-container>

        <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element" class="expand-button">
                <button style="margin-top: 2px; margin-bottom: 2px;" mat-icon-button aria-label="expand row"
                    (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                    @if (expandedElement === element) {
                    <mat-icon>keyboard_arrow_up</mat-icon>
                    } @else {
                    <mat-icon>keyboard_arrow_down</mat-icon>
                    }
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayCols.length" class="detail-cell">
                <div class="example-element-detail"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <details-requests [id]="element.id" [type]="getWorkflowRequestType(element.type)"
                        [startSearch]="expandedElement != null && element.id == expandedElement.id"
                        [showTitle]="false"></details-requests>
                    @if(expandedElement != null && expandedElement.id == element.id){
                    <div style="text-align: center; width: 100%;">
                        <button mat-button
                            (click)="expandedElement = null"><mat-icon>keyboard_arrow_up</mat-icon></button>
                    </div>
                    }
                </div>
            </td>
        </ng-container>

        @if (includeDelete) {
        <ng-container matColumnDef="del">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" style="text-align:center;">
                <button mat-icon-button matSuffix (click)="deleteRow(element)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
        <tr mat-row *matRowDef="let element; columns: displayCols;" class="example-element-row"
            [class.example-expanded-row]="expandedElement === element" (click)="openRequestInNewTab(element)">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    @if (includePaginator) {
    <mat-paginator [hidden]="requestsDataSource.data.length == 0" [length]="requestsDataSource.data.length"
        [pageSizeOptions]="[10, 20, 30, 40]" showFirstLastButtons></mat-paginator>
    }
</form>